import React from 'react';
import { Box, TextField, Button } from '@mui/material';

const Filter = ({ filter, setFilter, onApply }) => {
  const handleApply = () => {
    onApply(filter); // always pass current value
  };

  const handleClear = () => {
    setFilter('');
    onApply(''); // pass empty string directly ..okay
  };

  return (
    <Box display="flex" gap={2} alignItems="center" mb={3}>
      <TextField
        label="Search Username"
        variant="outlined"
        size="small"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onApply(filter);
        }}
      />
      <Button variant="contained" onClick={handleApply}>
        Apply
      </Button>
      <Button variant="outlined" onClick={handleClear}>
        Clear
      </Button>
    </Box>
  );
};

export default Filter;
